import { useMutation } from '@tanstack/react-query';
import { UseFormReturn } from 'react-hook-form';

import { useMutationHTTPRequest } from 'api/hooks/useHTTPRequest';
import { logError } from 'lib/sentry/logError';

import { useSessionTranscriptQueryActions } from 'features/sessions/hooks/useSessionTranscriptQueryActions';

import { showErrorToast, showSuccessToast } from 'shared/components/Toast';

export const useSessionTranscriptAddMutation = (
  sessionId: string,
  setValue: UseFormReturn['setValue']
) => {
  const { request } = useMutationHTTPRequest();

  const { resetTranscript, setTranscript } =
    useSessionTranscriptQueryActions(sessionId);

  return useMutation<{ transcript: string }, Error, { transcript: string }>(
    async ({ transcript }) =>
      request({
        url: `/api/coach/coaching-sessions/${sessionId}/transcript/add`,
        body: {
          transcript,
        },
      }),
    {
      onMutate: ({ transcript }) => {
        setTranscript(transcript);
      },
      onSuccess: () => {
        showSuccessToast('Transcript has been updated.');
        setValue('isTranscriptAvailable', true);
      },
      onError: (error) => {
        resetTranscript();
        showErrorToast('Failed to add transcript.');
        logError(error);
      },

      useErrorBoundary: false,
    }
  );
};
